import { useHistoryCustomBack } from 'weblite-router'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
// Components
import { BottomDrawer } from '$common/bottom-drawer'
import { ConnectivityToolsSelectMenu } from '$comp/navigation-bar-tool-box/components/connectivity-tools-select-menu'
import { showToolboxModal } from '$comp/modals/toolbox/index'

export function ToolboxCommunicationToolsModal({
  isOpen,
}: {
  isOpen: boolean
}) {
  const onBack = async () => {
    await closeCurrentModal()
    showToolboxModal()
  }

  useHistoryCustomBack(onBack, [])

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={closeCurrentModal}
      bottomSafeAreaColor="veryLightGray"
    >
      <ConnectivityToolsSelectMenu onBack={onBack} />
    </BottomDrawer>
  )
}
